import { proctorApi, type RecordViolationRequest } from "@/lib/proctorApi";

// localStorage-backed outbox. IndexedDB would be more robust for large queues; for the M5
// scope (few violation events per attempt) localStorage is sufficient and dead-simple.
const KEY = "proctorOutbox";

interface OutboxItem {
  id: string;
  attemptId: string;
  body: RecordViolationRequest;
}

function load(): OutboxItem[] {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]") as OutboxItem[]; }
  catch { return []; }
}

function save(items: OutboxItem[]) {
  localStorage.setItem(KEY, JSON.stringify(items));
}

let flushing = false;

export const violationOutbox = {
  enqueue(attemptId: string, body: RecordViolationRequest) {
    const items = load();
    items.push({ id: crypto.randomUUID(), attemptId, body });
    save(items);
  },

  async flush(): Promise<{ terminal: boolean }> {
    if (flushing) return { terminal: false };
    flushing = true;
    let terminal = false;
    try {
      let items = load();
      while (items.length > 0) {
        const next = items[0];
        try {
          const r = await proctorApi.reportViolation(next.attemptId, next.body);
          if (r.terminal) terminal = true;
        } catch {
          // Network error — leave item at head, try later.
          break;
        }
        items = items.slice(1);
        save(items);
      }
    } finally {
      flushing = false;
    }
    return { terminal };
  },

  size() { return load().length; },
};
